// @flow
import React from 'react'
import _ from 'lodash'
import LimitedInput from '../AdEdit/AdInputs/LimitedInput'
import LabeledWrapper from '../AudienceEdit/LabeledWrapper'
import styled from 'styled-components'

const customQuestionOptionMaxLength = 60

const t = {
  option: 'Вариант',
  remove: 'удалить',
  add: '+ добавить вариант'
}

type Props = {|
  data: Array<string>,
  onChange: (Array<string>) => void
|}

const Link = styled.a`
  margin-left: 90px;
`

export default function Options({ data, onChange }: Props) {
  const allowedToRemove = data.length > 2
  return (
    <div>
      {_.map(data, (option, index: number) => {
        const label = (
          <div>
            <div>
              {t.option} {index + 1}
            </div>
            {allowedToRemove && (
              <div>
                <span> [</span>
                <a
                  href="#"
                  onClick={(e) => {
                    const options = _.cloneDeep(data)
                    options.splice(index, 1)
                    onChange(options)
                    e.preventDefault()
                  }}
                >
                  {t.remove}
                </a>
                <span>]</span>
              </div>
            )}
          </div>
        )
        return (
          <LabeledWrapper label={label} twoLines={allowedToRemove} bottomPadding={8} key={index}>
            <LimitedInput
              className={`t-LeadformCustomQuestion__option_${index}`}
              maxLength={customQuestionOptionMaxLength}
              value={option}
              onChange={(value) => {
                const options = _.cloneDeep(data)
                options[index] = value
                onChange(options)
              }}
            />
          </LabeledWrapper>
        )
      })}
      {data.length < 15 ? (
        <Link
          href="#"
          onClick={(e) => {
            onChange([...data, ''])
            e.preventDefault()
          }}
        >
          {t.add}
        </Link>
      ) : null}
    </div>
  )
}
